export default __webpack_public_path__ + "static/media/Qq.c28ed595.wav";